import store from "@/redux/store";

import React, { useState, useEffect } from "react";
import { connect } from "react-redux";


class MediaController extends React.Component {
  constructor(props) {
    super(props);
        this.state = {
      recording: false,
      audios: [],
      urlQueue: [],
      audioURL: null,
        };
        this.startRecording = this.startRecording.bind(this);
        let chunks = [];
  }

  /* Process Buffer Array And Add Url To UrlQueue */
  async componentDidMount() {
if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  const stream = await navigator.mediaDevices
    .getUserMedia(
      {
        audio: true,
      },
    )

    // Success callback
    .then((stream) => {
    // init recording
let options = {
        audioBitsPerSecond: 128000,
      };    
    
    this.mediaRecorder = new MediaRecorder(stream, options);
     //this.mediaRecorder.mimeType = 'audio/webm;codecs=opus';
//this.mediaRecorder.SetAudioSource(AudioSourceBuffer.);           
// this.mediaRecorder.SetAudioEncodingBitRate(128000);
// this.mediaRecorder.SetAudioSamplingRate(16000);    
    // init data storage for video chunks
    // listen for data from media recorder
    this.mediaRecorder.ondataavailable = e => {
      if (e.data && e.data.size > 0) {
        this.chunks.push(e.data);
        this.setBuffer();
      }
    };       
    this.mediaRecorder.onstart = () => {
  // do something in response to
  // recording being started
      
    }; 
    })

    // Error callback
    .catch((err) => {
      
    });
} else {
  
}
    
  }

  startRecording(e) {
      const {recording, audios} = this.state;
      
      if(!recording) {
          
        e.preventDefault();
        // wipe old data chunks
        this.chunks = [];
        // start recorder with 10ms buffer
        //this.mediaRecorder.start(10);
        this.mediaRecorder.start();
        // say that we're recording
        this.setState({recording: true});
        
     } else {
        this.mediaRecorder.stop();
        this.setState({recording: false});         
     }
    
  }

setBuffer() {
        let buffers = this.chunks;
        const audioData = new Uint8Array(buffers.flat());
        const blob = new Blob(this.chunks, { type: "audio/wav; base64" });
        
        const url = window.URL.createObjectURL(blob);
        
        this.setState({audioURL: url});
        this.playNAudio(url);
        //setUrlQueue((prevUrlQueue) => [...prevUrlQueue, url]);
        
        this.chunks = [];    
}

async playNAudio(nextUrl) {
//      const nextUrl = urlQueue[0];
      try {
//        if (urlQueue.length) {
          const audio = new Audio();
          //setAudioPlaying(audio);

          audio.src = nextUrl;
          audio.autoplay = true;
          audio.preload = "auto";
          //setIsPlaying(true);
          audio.onended = () => {
//            setIsPlaying(false);
//            setUrlQueue((prevQ) => prevQ.slice(1));
          };
//          setAudioElem(audio);
//        }
      } catch (error) {
        
      }
    };
//    if (!isPlaying && urlQueue.length > 0) {
//      playNAudio();
//    }

    
    getView =()=> {
        const {audioURL} = this.state;
        return (<><div className="absolute z-30 h-1/6"><span className="z-30 bg-red-900" onClick={this.startRecording}>SPEAK</span>{audioURL && <audio controls style={{width: 200}} src={audioURL}   />}</div></>);
    }
    
  render() {
    return this.getView();
  }
}

const MediaControllerInit = (props) => {
    
  return (
    <MediaController
      {...props} 
    />
  );
};

function mapStateToProps(state) {
  return {
  };
}
export default connect(mapStateToProps)(MediaControllerInit);
